import Login from "./pages/login";
import Home from "./components/UI/layout/home";
import theme from "./components/theme"
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CssVarsProvider } from "@mui/joy";
import { UIContextProvider } from "./store/ui";
import { SessionContextProvider } from "./store";
import RecoverPassword from "./pages/recoverPassword";
import RecoverPasswordPage from "./pages/recover-password";
import ChangePasswordRequired from "./pages/change-password-required";
import ManualCrixtoPage from "./pages/manual-crixto";
import TransactionsReportPage from "./pages/transactions";
import AdminPage from "./pages/admin";
import WithdrawalsPage from "./pages/withdrawals";
import ReferidosPage from "./pages/referidos";
import ProtectedRoute from "./components/common/ProtectedRoute";

const App = () => {

  return (
      <CssVarsProvider theme={theme} defaultMode="system">
        <SessionContextProvider>
          <UIContextProvider>
            <BrowserRouter>
              <Routes>            
                <Route path="/" element={<Login />} />
                <Route path="/recover_password" element={<RecoverPassword />} />
                <Route path="/partners/recover-password" element={<RecoverPasswordPage />} />
                <Route path="/change-password-required" element={<ChangePasswordRequired />} />
                
                {/* Ruta de Operaciones - accesible por admin y operator */}
                <Route path="/tx" element={
                  <ProtectedRoute allowedRoles={['admin', 'operator']}>
                    <Home><ManualCrixtoPage /></Home>
                  </ProtectedRoute>
                } />
                
                {/* Ruta de Transacciones - accesible por admin y operator */}
                <Route path="/transactions" element={
                  <ProtectedRoute allowedRoles={['admin', 'operator']}>
                    <Home><TransactionsReportPage /></Home>
                  </ProtectedRoute>
                } />

                {/* Ruta de Admin - solo accesible por admin */}
                <Route path="/admin" element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <Home><AdminPage /></Home>
                  </ProtectedRoute>
                } />

                {/* Ruta de Retiros - solo accesible por admin */}
                <Route path="/withdrawals" element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <Home><WithdrawalsPage /></Home>
                  </ProtectedRoute>
                } />
                
                {/* Ruta de Referidos - solo admin (referrals = competencia del admin) [#34] */}
                <Route path="/referidos" element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <Home><ReferidosPage /></Home>
                  </ProtectedRoute>
                } />

                {/* Ruta por defecto */}
                <Route path="*" element={
                  <ProtectedRoute allowedRoles={['admin', 'operator']}>
                    <Home><ManualCrixtoPage /></Home>
                  </ProtectedRoute>
                } />
              </Routes>
            </BrowserRouter>   
          </UIContextProvider>
        </SessionContextProvider>
      </CssVarsProvider>
  );
}

export default App;